import {
  PURCHASER_OWNER_DATA_REQUEST,
  PURCHASER_OWNER_DATA_SUCCESS,
  PURCHASER_OWNER_DATA_FAIL,
} from '../constants/purchaserOwnerConstants';

export const purchaserOwnerReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case PURCHASER_OWNER_DATA_REQUEST:
      return { loading: true, formData: [] };
    case PURCHASER_OWNER_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case PURCHASER_OWNER_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
